import React from 'react'
import DOMPurify from 'dompurify'
import { Image } from 'src/components/ui/Image'

interface InsuranceSteperItem {
  text: string
}

interface InsuranceStepers {
  title: string
  items: InsuranceSteperItem[]
}

interface InsuranceSectionClubSantuuProps {
  logo: string
  title: string
  description: string
  insuranceStepers: InsuranceStepers
}

const InsuranceSectionClubSantuu: React.FC<InsuranceSectionClubSantuuProps> = ({
  logo,
  title,
  description,
  insuranceStepers,
}) => (
  <section className="w-full max-w-[1280px] bg-[#3A48C6] mx-auto mb-14 md:mb-20 px-7 md:px-10 py-12 flex flex-col md:flex-row items-center justify-between">
    <div className="flex flex-col md:flex-row items-start sm:items-center gap-5 md:gap-8">
      <Image src={logo} alt="Logo Clube Santuu" className="w-32 h-auto" />
      <div>
        <h2 className="text-white text-2xl sm:text-font-size-8 md:text-3xl font-medium sm:font-bold mb-4">
          {title}
        </h2>
        <p className="text-white text-sm md:text-base font-normal max-w-lg">
          {description}
        </p>
      </div>
    </div>
    <div className="flex-1 mt-8 md:mt-0 md:ml-12">
      <h3 className="text-white text-sm md:text-base font-semibold mb-4">
        {insuranceStepers.title}
      </h3>
      <ol className="space-y-4">
        {insuranceStepers.items.map((item, idx) => (
          <li key={idx} className="flex items-start gap-3">
            <span className="bg-white text-[#101010] text-xs font-semibold rounded-full min-w-8 h-8 flex items-center justify-center">
              {idx + 1}
            </span>
            <span
              className="text-white text-sm font-semibold [&_a]:underline"
              dangerouslySetInnerHTML={{
                __html:
                  typeof DOMPurify?.sanitize === 'function'
                    ? DOMPurify?.sanitize(item.text)
                    : item.text,
              }}
            />
          </li>
        ))}
      </ol>
    </div>
  </section>
)

export default InsuranceSectionClubSantuu
